import React, { Fragment, useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import img from "../Loader/spinner.gif";
import { obtenerInstituciones } from "../../Services/Rest";
import Swal from "sweetalert2";

function CreaUsuario() {
  const [isLoading, setLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);

  const handleOpenModalTest = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  // Estado para instituciones
  const [institucion, setInstitucion] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: obtenerInstituciones,
    })
      .then((Response) => {
        setInstitucion(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // ✅ Estado para tipos de usuario desde API
  const [tiposUsuario, setTiposUsuario] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/ObtenerTipoUsuario/",
    })
      .then((response) => {
        setTiposUsuario(response.data);
        console.log("Tipos de Usuario:", response.data);
      })
      .catch((error) => {
        console.error("Error al cargar tipos de usuario:", error);
      });
  }, []);

  // Estados para campos del formulario
  const [postNombre, setPostNombre] = useState("");
  const [postCorreo, setPostCorreo] = useState("");
  const [postContrasena, setPostContrasena] = useState("");
  const [postTipoUsuario, setPostTipoUsuario] = useState("");
  const [postInstitucion, setPostInstitucion] = useState("");

  const postData = (e) => {
    e.preventDefault();
    setLoading(true);

    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaUsuario",
      data: {
        nombre: postNombre,
        correo_Electronico: postCorreo,
        contrasena: postContrasena,
        tipo_Usuario: postTipoUsuario,
        institucionId: postInstitucion,
        rol: "1",
      },
    })
      .then((Response) => {
        console.log(Response.data);
        Swal.fire({
          icon: "success",
          title: "Usuario creado correctamente",
          text: "El usuario fue registrado exitosamente.",
          confirmButtonText: "Aceptar",
        }).then(() => {
          window.location.reload("/");
        });
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Error al crear usuario",
          text: error?.response?.data || "Ocurrió un error inesperado",
          confirmButtonText: "Entendido",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="test">
      <button
        variant="contained"
        className="btn btn-primary"
        onClick={handleOpenModalTest}
      >
        Nuevo usuario
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Usuario"
      >
        <div className="container">
          <div className="text-center">
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Crear Usuario
                  </h6>
                </div>
                <div className="card-body">
                  <form className="user">
                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <input
                          type="text"
                          className="form-control form-control-user"
                          placeholder="Nombre"
                          onChange={(e) => setPostNombre(e.target.value)}
                        />
                      </div>
                      <div className="col-sm-6">
                        <input
                          type="email"
                          className="form-control form-control-user"
                          placeholder="Correo electrónico"
                          onChange={(e) => setPostCorreo(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <input
                          type="password"
                          className="form-control form-control-user"
                          placeholder="Contraseña"
                          onChange={(e) => setPostContrasena(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <select
                          className="btn btn-secondary btn-user btn-block"
                          onChange={(e) => setPostTipoUsuario(e.target.value)}
                        >
                          <option value="">
                            Seleccione el Tipo de Usuario
                          </option>
                          {tiposUsuario.map((tipo) => (
                            <option key={tipo.id} value={tipo.id}>
                              {tipo.nombre}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <select
                          className="btn btn-secondary btn-user btn-block"
                          onChange={(e) => setPostInstitucion(e.target.value)}
                        >
                          <option value="">Seleccione la Institución</option>
                          <option value="0">ICONTEC</option>
                          {institucion.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.razon_Social}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {isLoading ? (
                      <div className="text-center">
                        <img
                          style={{ width: "200px", height: "200px" }}
                          src={img}
                          alt="Cargando..."
                        />
                      </div>
                    ) : (
                      <button
                        className="btn btn-primary btn-user btn-block"
                        onClick={postData}
                      >
                        Guardar
                      </button>
                    )}
                    <hr />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default CreaUsuario;
